__turbopack_context__.v({
  "bottomBtn": "login-module-scss-module__HzK74W__bottomBtn",
  "checkRemember": "login-module-scss-module__HzK74W__checkRemember",
  "copyright": "login-module-scss-module__HzK74W__copyright",
  "formItem": "login-module-scss-module__HzK74W__formItem",
  "inputIcon": "login-module-scss-module__HzK74W__inputIcon",
  "license": "login-module-scss-module__HzK74W__license",
  "licenseBottom": "login-module-scss-module__HzK74W__licenseBottom",
  "licenseContent": "login-module-scss-module__HzK74W__licenseContent",
  "login": "login-module-scss-module__HzK74W__login",
  "loginBackground": "login-module-scss-module__HzK74W__loginBackground",
  "loginBottom": "login-module-scss-module__HzK74W__loginBottom",
  "loginContent": "login-module-scss-module__HzK74W__loginContent",
  "loginContentElectron": "login-module-scss-module__HzK74W__loginContentElectron",
  "loginForm": "login-module-scss-module__HzK74W__loginForm",
});
